export default __webpack_public_path__ + "static/143-0265eddcfb975e1df6134ffb4947a069.jpg";